var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isBlocked)?_c('div',{staticClass:"d-inline"},[_c('a',{staticClass:"text-underline",attrs:{"href":"#","target":"_blank"},on:{"click":function($event){$event.preventDefault();return _vm.reveal()}}},[_vm._v("megjelenít")])]):_c('div',{staticClass:"d-inline"},[_c('a',{attrs:{"href":_vm.emailLink}},[_vm._v(_vm._s(_vm.emailText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }